<template>
  <!-- <v-card> -->
  <!-- <card-title-bar icon="mdi-cart-outline" text="カートに入っている商品"></card-title-bar> -->

  <div>
    <!-- カートが空のとき -->
    <div v-if="showEmptyMessage" class="text-body-2 grey--text">
      カートに商品はありません
    </div>

    <!-- カートに商品がある時 -->
    <v-list three-line>
      <template v-for="(item, index) in cart">
        <v-list-item :key="index" class="px-0">
          <!-- 商品画像 -->
          <v-list-item-avatar size="55" class="item-pic">
            <v-img :src="item.image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content class="pb-0">
            <!-- 商品名 -->
            <v-list-item-title class="text-body-2">
              {{ item.merchandiseName }} - {{ item.typeName }}
            </v-list-item-title>
            <!-- 価格 -->
            <v-list-item-subtitle>
              価格:
              {{
                item.price | toPriceFormat | addSpPriceMark(item.priceTypeId)
              }}
            </v-list-item-subtitle>
            <div align="end">
              <!-- 数量 -->
              <v-btn icon left @click="decrementQty(item)">
                <v-icon color="grey lighten-1">mdi-minus-circle-outline</v-icon>
              </v-btn>
              <span>数量:{{ item.qty }}</span>
              <v-btn icon right @click="incrementQty(item)">
                <v-icon color="grey lighten-1">mdi-plus-circle-outline</v-icon>
              </v-btn>
              <span class="mx-5">{{ item.amount | toPriceFormat }}</span>
              <!-- 削除 -->
              <trash-can-btn
                tooltip-text="カートから削除"
                @trash-btn-click="removeItem(item)"
              ></trash-can-btn>
            </div>
          </v-list-item-content>
        </v-list-item>

        <!-- 区切り線 -->
        <v-divider :key="`divider${index}`"></v-divider>
      </template>
    </v-list>

    <!-- 商品小計 -->
    <div align="end" class="mt-3">
      <!-- 小計金額 -->
      <span class="mx-5">商品小計: {{ merchSubTotal | toPriceFormat }}</span>
      <!-- 全削除 -->
      <trash-can-btn
        tooltip-text="カートを空にする"
        @trash-btn-click="clearCart"
      ></trash-can-btn>
    </div>
  </div>
  <!-- </v-card> -->
</template>

<script>
// import CardTitleBar from '../common/CardTitleBar.vue'
import TrashCanBtn from '../common/TrashCanBtn.vue';

export default {
  name: 'CartContents',
  components: {
    // CardTitleBar,
    TrashCanBtn,
  },
  props: {
    cart: Array,
    showEmptyMessage: Boolean,
    merchSubTotal: Number,
  },
  methods: {
    incrementQty(item) {
      this.$emit('increment-qty-click', item);
    },
    decrementQty(item) {
      this.$emit('decrement-qty-click', item);
    },
    removeItem(item) {
      this.$emit('remove-item-click', item);
    },
    clearCart() {
      this.$emit('clear-cart-click');
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 510px) {
  /* 商品画像の非表示 */
  .item-pic {
    display: none;
  }
}
</style>
